"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScopePermissions = exports.queryKeys = void 0;

var _reactQuery = require("react-query");

var _request = require("@nicbase/request");

var _types = require("@nicbase/types");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getScopePermissions = function getScopePermissions(scope) {
  var portalId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return {
    type: 'GET_SCOPE_PERMISSIONS_REQUEST',
    headers: {
      version: 'v1',
      scope: scope,
      portalId: portalId
    }
  };
};

var queryKeys = {
  all: function all() {
    return ['permissions'];
  },
  scope: function scope(_scope, portalId) {
    return [].concat(_toConsumableArray(queryKeys.all()), [_scope, portalId]);
  },
  portal: function portal(portalId) {
    return _toConsumableArray(queryKeys.scope(_types.Scope.Portal, portalId));
  },
  admin: function admin() {
    return _toConsumableArray(queryKeys.scope(_types.Scope.Admin));
  }
};
exports.queryKeys = queryKeys;

var useScopePermissions = function useScopePermissions(scope, portalId, queryOptions) {
  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  return (0, _reactQuery.useQuery)(_toConsumableArray(queryKeys.scope(scope, portalId)), /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _yield$request, body;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return request(getScopePermissions(scope, portalId));

          case 2:
            _yield$request = _context.sent;
            body = _yield$request.body;
            return _context.abrupt("return", body === null || body === void 0 ? void 0 : body.permissions);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), queryOptions);
};

exports.useScopePermissions = useScopePermissions;